import { Injectable } from '@angular/core';
// import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
@Injectable({
  providedIn: 'root'
})
export class SessionTimeoutService {

  /*Count down code variables*/
  timed: boolean = false;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  countdown: any;
  sessionTimeOutTime: any = null
  constructor() { }

  // watchSessionTimeOut() {
  //   // sets an idle timeout of 5 seconds, for testing purposes.
  //   this.idle.setIdle(3000);
  //   // sets a timeout period of 5 min. after 10 seconds of inactivity, the user will be considered timed out.
  //   this.idle.setTimeout(60);
  //   // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
  //   this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
  //   this.idle.onInterrupt.subscribe(resp => {
  //     this.sessionTimeOutTime = null
  //   }
  //   );
  //   this.idle.onIdleEnd.subscribe(res => {
  //     this.idleState = 'No longer this.idle.'
  //     this.sessionTimeOutTime = null
  //   });

  //   this.idle.onTimeout.subscribe(() => {
  //     this.idleState = 'Timed out!';
  //     this.timedOut = true;
  //     this.sessionTimeOutTime = null
  //   });

  //   this.idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone this.idle!');
  //   this.idle.onTimeoutWarning.subscribe((countdown) => {
  //     this.idleState = 'You will timevxc out in ' + countdown + ' seconds!';
  //     this.sessionTimeOutTime = countdown;
  //     if (countdown == 1) {
  //       this.timed = true;
  //       this.sessionTimeOutTime = null
  //     }
  //   });
  //   // sets the ping interval to 15 seconds
  //   this.reset();
  // }
  // reset() {
  //   this.idle.watch();
  //   this.idleState = 'Started.';
  //   this.timedOut = false;
  // }

  // stop(){
  //   this.idle.stop()
  // }
}
